import { safeNum } from '../extractors/_shared';
const buildJ = (emoji, zh, en, positive) => ({ emoji, labelZh: zh, labelEn: en, positive });

/** ratio = 解锁量 / 总供应量 */
export function judgeUnlockPressure30d(ratio) {
  const r = safeNum(ratio);
  if (r == null) return null;
  if (r < 0.005) return buildJ('🟢', '稳定期',    'Stable',     true);
  if (r < 0.02)  return buildJ('🟢', '压力较小',  'Low',        true);
  if (r < 0.05)  return buildJ('🟡', '压力中等',  'Medium',     null);
  return            buildJ('🔴', '高抛压',    'High',       false);
}
export function judgeUnlockPressure180d(ratio) {
  const r = safeNum(ratio);
  if (r == null) return null;
  if (r < 0.05) return buildJ('🟢', '中期稳定', 'Stable',  true);
  if (r < 0.15) return buildJ('🟢', '可控',     'Manageable', true);
  if (r < 0.30) return buildJ('🟡', '需关注',   'Watch',   null);
  return           buildJ('🔴', '中期高压', 'High',    false);
}
export function judgeTeamShare(share) {
  const r = safeNum(share);
  if (r == null) return null;
  if (r < 0.20) return buildJ('🟢', '团队占比合理', 'Healthy',  true);
  if (r < 0.35) return buildJ('🟢', '团队占比正常', 'Normal',   true);
  if (r < 0.50) return buildJ('🟡', '团队占比偏高', 'Elevated', null);
  return           buildJ('🔴', '团队占比过高', 'High',     false);
}
